import { i18ns } from '@naruto/naruto-models/src/core/i18n';
import LocalStorageOperation from '@naruto/naruto-models/src/core/localStorageOperator';
import { SET_USER_INITIALIZE_APPLICATION } from '@naruto/bgdapp/src/reducers/cores/user/actions';
import { SET_GLOBAL_INITIALIZE } from '@naruto/naruto-reducers/src/reducers/global/actions';
import { SET_MESSAGE_DIALOG } from '@naruto/naruto-reducers/src/reducers/message/actions';
import { ThunkAction, Models, MiddleWare, BaseErrorStack, TokenStoreName, MessageDialogObject } from './types';

export const errorCatch =
  (
    error?: BaseErrorStack,
    statusCode?: number,
    actions?: () => void,
    showErrorMessage = true
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { env }): Promise<void> => {
    if (error) {
      const localStorageReader = new LocalStorageOperation<TokenStoreName>({
        savedStorageItemName: env.config.JwtTokenLocalName
      });
      const messageHiddenTitle = '';
      const messageHidden = '';
      const messageTitle = i18ns.__('frontend.global.error.0000');
      let messageContent = '';
      if (error.errors) {
        Object.keys(error.errors).forEach(key => {
          if (error.errors) {
            const value = error.errors[key];
            if (Array.isArray(value)) {
              value.forEach(err => {
                messageContent += `${key} : ${err}\n`;
              });
            }
          }
        });
      } else {
        messageContent = error.message;
      }
      const dialog: MessageDialogObject = {
        typeMessage: 'danger',
        typeTitle: messageTitle,
        typeContent: messageContent,
        showHiddenMessage: showErrorMessage,
        onConfirm: () => {
          if (actions) {
            actions();
          }
        }
      };
      if (messageHidden || messageHiddenTitle) {
        dialog.typeHiddenMessageTitle = messageHiddenTitle;
        dialog.typeHiddenMessage = messageHidden;
      }
      if (statusCode === 401) {
        localStorageReader.deleteStorage();
        dispatch(SET_GLOBAL_INITIALIZE());
        dispatch(SET_USER_INITIALIZE_APPLICATION());
      }
      dispatch(SET_MESSAGE_DIALOG({ dialog }));
    }
  };
